import { useEffect, useState } from "react";
import InTheHeadlight from "../ourCars/inTheHeadlight";
import OurInstantWinPrizes from "./instantWinPrizes/ourInstantWinPrizes";
import { getInstantWinDataOnInstantWinTab } from "../../dreamCar-service";
import { InstantWinTabProps } from "./types";

const OurInstantWin = ({ competitionTypeId, competitionId }: { competitionTypeId: string; competitionId: number }) => {
  const [isInstantWinActive, setIsInstantWinActive] = useState(false);
  const [showTabbedVersion, setShowTabbedVersion] = useState(false);

  useEffect(() => {
    (async () => {
      const response = await getInstantWinDataOnInstantWinTab(competitionTypeId, competitionId);
      const { shouldShowInstantWinTabContent, shouldShowTabbedVersion } = (await response.json()) as InstantWinTabProps;
      setIsInstantWinActive(shouldShowInstantWinTabContent);
      setShowTabbedVersion(shouldShowTabbedVersion);
    })();
  }, []);

  return (
    isInstantWinActive && (
      <div className="instantWinPrizes" style={{ display: "none" }}>
        <InTheHeadlight prizeCategory="instantwin" classNames="instantWinITH" />
        <OurInstantWinPrizes showTabbedVersion={showTabbedVersion} competitionId={competitionId} />
      </div>
    )
  );
};

export default OurInstantWin;
